import React from 'react';
import * as PropTypes from 'prop-types';
import { constants } from 'cv-react-core';
import { ThreeOneLeftForm as ThreeOneLeftFormBase } from 'cv-library-react-web';

import getStyles from './ThreeOneLeftForm.styles';

const ThreeOneLeftForm = (props) => {
    const {
        formElements,
        onResizeStop,
        ...rest
    } = props;
    const styles = getStyles();
    const { ui } = constants;

    const handleResizeStop = (e, dir, ref) => {
        const viewId = ref.getAttribute('viewid');
        const {
            style: {
                width,
                height,
            },
        } = ref;
        onResizeStop(viewId, width, height);
    };

    return (
        <ThreeOneLeftFormBase
            contextStyles={ styles }
            formElements={ formElements }
            onResizeStop={ handleResizeStop }
            scrollIdentifier={ ui.SCROLL_CONTAINER }
            { ...rest } />
    );
};

ThreeOneLeftForm.propTypes = {
    formElements: PropTypes.arrayOf(PropTypes.element),
    onResizeStop: PropTypes.func,
};

ThreeOneLeftForm.defaultProps = {
    formElements: {},
};

export default ThreeOneLeftForm;
